module.exports = __webpack_public_path__ + "static/img/challenge_warriors_bg.34d4c64e.png";